<template>
  <b-modal
    ref="inventory-check-history"
    title="Lịch sử cập nhật"
    id="inventory-check-history"
    no-close-on-backdrop
    size="xl"
  >
    <b-table
      caption-top
      responsive
      bordered
      hover
      :fields="fields"
      :items="stockCheckProductLogs"
      id="my-table"
    >
      <template #cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <template #cell(updatedAt)="data">
        {{ formatDate(data.item.updatedAt, CLIENT_DATE_TIME) }}
      </template>
      <template #cell(sourceType)="data">
        {{ getSourceTypeName(data.item.sourceType) }}
      </template>

      <template #cell(detail)="data">
        <div v-if="data.item.sourceType">
          <span class="font-weight-bold">Nguồn:</span>
          {{ getSourceTypeName(data.item.sourceType) }}
        </div>
        <div>
          <span class="font-weight-bold">Thời gian:</span>
          {{ formatDate(data.item.updatedAt, CLIENT_DATE_TIME) }}
        </div>
        <div v-if="isShowDetail(data.item.changes)">
          <div class="font-weight-bold">Chi tiết:</div>
          <b-table
            small
            :items="Object.entries(data.item.changes)"
            :fields="changeFields"
            responsive
            bordered
            hover
          >
            <template #cell(field)="fieldData">
              {{ fieldNameMap[fieldData.item[0]] || fieldData.item[0] }}
            </template>
            <template #cell(oldValue)="fieldData">
              <div v-if="fieldData.item[0] === 'realImeiNos'">
                <div
                  v-if="toImeiArray(fieldData.item[1].oldValue).length"
                  class="imei-container"
                >
                  <div
                    v-for="(imei, index) in toImeiArray(fieldData.item[1].oldValue)"
                    :key="index"
                    class="imei-item"
                  >
                    {{ index + 1 }}) {{ imei }}
                  </div>
                </div>
                <span v-else class="text-muted">—</span>
              </div>
              <span v-else>{{ fieldData.item[1].oldValue }}</span>
            </template>
            <template #cell(newValue)="fieldData">
              <div v-if="fieldData.item[0] === 'realImeiNos'">
                <div
                  v-if="toImeiArray(fieldData.item[1].newValue).length"
                  class="imei-container"
                >
                  <div
                    v-for="(imei, index) in toImeiArray(fieldData.item[1].newValue)"
                    :key="index"
                    class="imei-item"
                  >
                    {{ index + 1 }}) {{ imei }}
                  </div>
                </div>
                <span v-else class="text-muted">—</span>
              </div>
              <span v-else>{{ fieldData.item[1].newValue }}</span>
            </template>
          </b-table>
        </div>
      </template>
    </b-table>
    <template #modal-footer>
      <b-button variant="secondary" @click="hideModal">Đóng</b-button>
    </template>
  </b-modal>
</template>

<script>
import { formatDate, CLIENT_DATE_TIME } from '@/utils/date';
import { STOCK_CHECK_PRODUCT_LOG_SOURCE_TYPE_NAME } from '@/utils/enum-name';
import { isEmpty } from 'lodash';

export default {
  name: 'InentoryHistoryModal',
  props: {
    stockCheckProductLogs: {
      required: true,
    },
  },
  watch: {
    stockCheckProductLogs(newVal) {
      this.stockCheckProductLogs = newVal;
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'index',
          label: 'STT',
          thStyle: { width: '2%' },
          tdClass: 'text-center',
        },
        {
          key: 'actionName',
          label: 'Hành động',
          tdClass: 'font-weight-bold',
          thStyle: { width: '10%' },
        },
        {
          key: 'updatedByName',
          label: 'Người cập nhật',
          thStyle: { width: '13%' },
          tdClass: 'font-weight-bold',
        },
        {
          key: 'detail',
          label: 'Nội dung',
          tdClass: 'text-left',
        },
      ],
      changeFields: [
        { key: 'field', label: 'Thuộc tính', thStyle: { width: '20%' } },
        { key: 'oldValue', label: 'Giá trị cũ', thStyle: { width: '40%' } },
        { key: 'newValue', label: 'Giá trị mới', thStyle: { width: '40%' } },
      ],
      CLIENT_DATE_TIME: CLIENT_DATE_TIME,
      fieldNameMap: {
        realImeiNos: 'Danh sách IMEI',
        realQuantity: 'Số lượng',
        note: 'Ghi chú',
      },
    };
  },
  methods: {
    formatDate,
    showModal() {
      this.$refs['inventory-check-history'].show();
    },
    hideModal() {
      this.$refs['inventory-check-history'].hide();
    },
    getSourceTypeName(sourceType) {
      return STOCK_CHECK_PRODUCT_LOG_SOURCE_TYPE_NAME[sourceType];
    },
    isShowDetail(changes) {
      return !isEmpty(changes);
    },
    toImeiArray(value) {
      if (Array.isArray(value)) return value.filter(Boolean);
      if (typeof value === 'string' && value.trim()) {
        try {
          const parsed = JSON.parse(value);
          if (Array.isArray(parsed)) return parsed.filter(Boolean);
        } catch (_) {
          // chuỗi phân cách bằng dấu phẩy
          return value.split(',').map((s) => s.trim()).filter(Boolean);
        }
      }
      return [];
    },
  },
};
</script>

<style lang="scss">
.inventory-check-history {
  background-color: aqua;
  table.b-table[aria-busy='true'] {
    opacity: 0.6;
  }
  .modal-dialog.modal-xl {
    max-width: 95vw;
  }
}

.imei-item {
  padding: 4px 8px;
  margin: 2px 0;
  background-color: #f8f9fa;
  border-left: 3px solid #007bff;
  border-radius: 3px;
  font-family: monospace;
  font-size: 0.9em;
  line-height: 1.4;
  text-align: left;
  display: block;
  width: 100%;
}

.imei-container {
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  justify-content: flex-start !important;
  vertical-align: top !important;
  text-align: left !important;
}

td .imei-container {
  vertical-align: top !important;
  text-align: left !important;
}

.b-table td {
  vertical-align: top !important;
}

.b-table td:has(.imei-container) {
  vertical-align: top !important;
  text-align: left !important;
}
</style>
